module.exports = __webpack_public_path__ + "img/partner10.f18aae27.png";